import axios from "axios";
import GetQrLink from "./getQrLink";
export { GetQrLink };

export const PhoneSmsApi = async (data) => {
  let response = null;
  const text = data?.textMessage ? data.textMessage : null;
  try {
    response = await axios.post(`/phone/ajax/new`, {
      qrTitle: data.qrTitle,
      phoneTo: data.valueTel,
      advertisingIabCategories: data.category || [],
      type: data.type,
      ...(text !== null && { text }),
    });
  } catch (error) {
    response = error.response;
  } finally {
    return response.data;
  }
};

export const PhoneSmsEditApi = async (data) => {
  let response = null;
  const text = data?.textMessage ? data.textMessage : null;
  try {
    response = await axios.post(`/phone/ajax/edit/${data.id}`, {
      qrTitle: data.qrTitle,
      phoneTo: data.valueTel,
      advertisingIabCategories: data.category || [],
      type: data.type,
      ...(text !== null && { text }),
    });
  } catch (error) {
    response = error.response;
  } finally {
    return response.data;
  }
};
